// import ReactDOM from "react-dom";
import Link from 'next/link'
import { route } from 'themes/route'
import Layout from 'themes/layouts/Home'
import { DatePicker, message } from 'antd';
import { Button, Row, Col, Typography } from 'antd';
import { useState } from "react";
import useBaseHook from 'themes/hooks/BaseHooks'
const { Title } = Typography
// import { bounce } from 'react-animations';
// const [hoverRef, isHovered] = useHover();

const Index = () => {
  const { t } = useBaseHook()
  return <Layout>
    <div id="bannerHeaderHome">
      <div className="container">
        <div className="contentTextInfoHeader">
        </div>
      </div>
    </div>

    <div>
      <div className="container">
        <div className="titleFeatureIndex">
          <h1 style={{ display: 'flex', justifyContent: 'center', fontSize: '30px', fontWeight: 'bold', color: '#004fff', textTransform: 'uppercase' }}>{t("home.index.service")}</h1>
        </div>
        <Row gutter={24}>
          <Col xs={12} lg={6} xl={6}>
            <div style={{ backgroundColor: '#18d7aa', width: '100%', height: '295px', borderRadius: '10px', opacity: '0.9' }}>
              <div style={{ top: '14%', textTransform: 'uppercase', position: 'relative' }}>
                <img src="/static/img/idea.jpeg"
                  style={{
                    width: '28%',
                    display: 'block',
                    margin: '0 auto',
                    marginBottom: '22px'
                  }}
                />
                <h1
                  style={{
                    textAlign: 'center',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '28px',
                    letterSpacing: '1.5px',
                    padding: '0 24px',
                  }}
                >{t("home.index.solutions")}</h1>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6} xl={6}>
            <div style={{ backgroundColor: '#18d7aa', width: '100%', height: '295px', borderRadius: '10px', opacity: '0.9' }}>
              <div style={{ top: '14%', textTransform: 'uppercase', position: 'relative' }}>
                <img src="/static/img/outsourcing.jpeg" style={{
                  width: '28%',
                  display: 'block',
                  margin: '0 auto',
                  marginBottom: '22px'
                }} />
                <h1 style={{
                  textAlign: 'center',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '28px',
                  letterSpacing: '1.5px',
                  padding: '0 24px',
                }}>{t("home.index.serviceOut")}</h1>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6} xl={6}>
            <div style={{ backgroundColor: '#18d7aa', width: '100%', height: '295px', borderRadius: '10px', opacity: '0.9' }}>
              <div style={{ top: '14%', textTransform: 'uppercase', position: 'relative' }}>
                <img src="/static/img/gear.jpeg"
                  style={{
                    width: '28%',
                    display: 'block',
                    margin: '0 auto',
                    marginBottom: '22px'
                  }}
                />
                <h1
                  style={{
                    textAlign: 'center',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '28px',
                    letterSpacing: '1.5px',
                    padding: '0 24px',
                  }}
                >{t("home.index.research")}</h1>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6} xl={6}>
            <div style={{ backgroundColor: '#18d7aa', width: '100%', height: '295px', borderRadius: '10px', opacity: '0.9' }}>
              <div style={{ top: '14%', textTransform: 'uppercase', position: 'relative' }}>
                <img src="/static/img/design-thinking.png"
                  style={{
                    width: '28%',
                    display: 'block',
                    margin: '0 auto',
                    marginBottom: '22px'
                  }}
                />
                <h1
                  style={{
                    textAlign: 'center',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '28px',
                    letterSpacing: '1.5px',
                    padding: '0 24px',
                  }}
                >{t("home.index.design")}</h1>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <div id="bannerItemShowInfoMqn">
      <div className="container">
        <div className="titleFeatureIndex">
          <h1 style={{ display: 'flex', justifyContent: 'center' }}>{t("home.index.productTitle")}</h1>
          <p>{t("home.index.productDescription")}</p>
        </div>
        <Row gutter={24}>
          <Col lg={12} xl={12}>
            <div className="itemImgBannerShow" style={{ paddingBottom: '50px' }}>
              <div
                style={{ backgroundColor: '#18d7aa', boxShadow: '0 3px 6px #9E9E9E', borderRadius: '5px', marginTop: '30px' }}
              >
                <div style={{ height: '180px', borderRadius: '5px 5px 0 0' }}>
                  <div style={{ position: 'relative', top: '13%' }}>
                    <h1 style={{ padding: '10px', color: '#fff', textTransform: 'uppercase', fontWeight: 700, textAlign: 'center', fontSize: '28px', letterSpacing: '1.5px' }}
                    >
                      {t("home.index.pro1")}
                    </h1>
                  </div>
                </div>
                <div style={{ height: '350px', position: 'relative', width: '100%', backgroundColor: '#fff' }}
                >
                  <p style={{ padding: '30px', textAlign: 'justify', fontSize: '16px' }}>
                    {t("home.index.des1")}
                  </p>
                </div>
                <Button style={{ width: "100%", color: '#18d7aa' }}>
                  {t("home.index.seen")}
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={12} xl={12}>
            <div className="itemImgBannerShow" style={{ paddingBottom: '50px' }}>
              <div
                style={{ backgroundColor: '#18d7aa', boxShadow: '0 3px 6px #9E9E9E', borderRadius: '5px', marginTop: '30px' }}
              >
                <div style={{ height: '180px', borderRadius: '5px 5px 0 0' }}>
                  <div style={{ position: 'relative', top: '13%' }}>
                    <h1 style={{ padding: '10px', color: '#fff', textTransform: 'uppercase', fontWeight: 700, textAlign: 'center', fontSize: '28px', letterSpacing: '1.5px' }}
                    >
                      {t("home.index.pro2")}
                    </h1>
                  </div>
                </div>
                <div style={{ height: '350px', position: 'relative', width: '100%', backgroundColor: '#fff' }}
                >
                  <p style={{ padding: '30px', textAlign: 'justify', fontSize: '16px' }}>
                    {t("home.index.des2")}
                  </p>
                </div>
                <Button style={{ width: "100%", color: '#18d7aa' }}>
                  <a href='/static/img/Thuyết minh kỹ thuật Phần Mềm Kết Nối, Khai Thác DLDC (1).pdf'>
                    {t("home.index.seen")}
                  </a>
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={12} xl={12}>
            <div className="itemImgBannerShow" style={{ paddingBottom: '50px' }}>
              <div
                style={{ backgroundColor: '#18d7aa', boxShadow: '0 3px 6px #9E9E9E', borderRadius: '5px', marginTop: '30px' }}
              >
                <div style={{ height: '180px', borderRadius: '5px 5px 0 0' }}>
                  <div style={{ position: 'relative', top: '13%' }}>
                    <h1 style={{ padding: '10px', color: '#fff', textTransform: 'uppercase', fontWeight: 700, textAlign: 'center', fontSize: '28px', letterSpacing: '1.5px' }}
                    >
                      {t("home.index.pro3")}
                    </h1>
                  </div>
                </div>
                <div style={{ height: '350px', position: 'relative', width: '100%', backgroundColor: '#fff' }}
                >
                  <p style={{ padding: '30px', textAlign: 'justify', fontSize: '16px' }}>
                    {t("home.index.des3")}
                  </p>
                </div>
                <Button style={{ width: "100%", color: '#18d7aa' }}>
                  <a href='/static/img/Tài liệu kỹ thuật từ Nhà sản xuất.pdf'>
                    {t("home.index.seen")}
                  </a>
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={12} xl={12}>
            <div className="itemImgBannerShow" style={{ paddingBottom: '50px' }}>
              <div
                style={{ backgroundColor: '#18d7aa', boxShadow: '0 3px 6px #9E9E9E', borderRadius: '5px', marginTop: '30px' }}
              >
                <div style={{ height: '180px', borderRadius: '5px 5px 0 0' }}>
                  <div style={{ position: 'relative', top: '13%' }}>
                    <h1 style={{ padding: '10px', color: '#fff', textTransform: 'uppercase', fontWeight: 700, textAlign: 'center', fontSize: '28px', letterSpacing: '1.5px' }}
                    >
                      {t("home.index.pro4")}
                    </h1>
                  </div>
                </div>
                <div style={{ height: '350px', position: 'relative', width: '100%', backgroundColor: '#fff' }}
                >
                  <p style={{ padding: '30px', textAlign: 'justify', fontSize: '16px' }}>
                    {t("home.index.des4")}
                  </p>
                </div>
                <Button style={{ width: "100%", color: '#18d7aa' }}>
                  {t("home.index.seen")}
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={12} xl={12}>
            <div className="itemImgBannerShow" style={{ paddingBottom: '50px' }}>
              <div
                style={{ backgroundColor: '#18d7aa', boxShadow: '0 3px 6px #9E9E9E', borderRadius: '5px', marginTop: '30px' }}
              >
                <div style={{ height: '240px', borderRadius: '5px 5px 0 0' }}>
                  <div style={{ position: 'relative', top: '13%' }}>
                    <h1 style={{ padding: '10px', color: '#fff', textTransform: 'uppercase', fontWeight: 700, textAlign: 'center', fontSize: '28px', letterSpacing: '1.5px' }}
                    >
                      {t("home.index.pro5")}
                    </h1>
                  </div>
                </div>
                <div style={{ height: '350px', position: 'relative', width: '100%', backgroundColor: '#fff' }}
                >
                  <p style={{ padding: '30px', textAlign: 'justify', fontSize: '16px' }}>
                    {t("home.index.des5")}
                  </p>
                </div>
                <div>
                  <Button style={{ width: "100%", color: '#18d7aa' }}>
                    <a href='/static/img/01_Catalog_DiemDanh (1).pdf'>
                      {t("home.index.seen")}
                    </a>
                  </Button>
                  <Button style={{ width: "100%", color: '#18d7aa' }}>
                    <a href='/static/img/HDSD hệ thống điểm danh sinh viên_Final.pdf'>
                      {t("home.index.hdsd")}
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>

  </Layout>
}
export default Index